import _get from 'lodash/get';
export var iconLibrary = {
  FontAwesome: 'FontAwesome',
  SemanticUI: 'SemanticUI'
};
export var iconNameLibraryMap = {
  tiktok: iconLibrary.FontAwesome
};
export var iconClassMap = {
  tiktok: ['fab', 'tiktok']
};
export function getLibraryFromIconName(iconName) {
  return _get(iconNameLibraryMap, iconName, iconLibrary.SemanticUI);
}
export function getIconClassFromIconName(iconName) {
  return _get(iconClassMap, iconName, []);
}